import { FactoryBase } from './factoryBase';

import type {
  EmptyJsonPub,
  EmptyPropsPub,
  EntityDataPubType,
  EntityPubType,
} from './entityBase';
import type { EntityDataType } from '@/infra/appsync';

/**
 * Entityの抽象クラス.以下を実装してください.
 * - createPvt(props: P): E
 * - createFromJsonPvt(props: J): E
 */
export abstract class Factory<E, P, J> extends FactoryBase<E, P, J, EmptyPropsPub, EmptyJsonPub> {
  /**
   * Entityを生成する.
   * @param props props.
   * @returns Entity.
   */
  abstract createPvt(props: P): E;

  /**
   * 作成
   * @param props プロパティ
   * @param _propsPub 公開プロパティ
   * @returns Entity
   */
  create(props: P, _propsPub: EntityPubType<EmptyPropsPub>): E {
    return this.createPvt(props);
  }

  /**
   * JSONからEntityを生成する.
   * @param props props.
   * @returns Entity.
   */
  abstract createFromJsonPvt(props: J): E;

  /**
   * 並び順を決めます.
   */
  abstract comparePvt: (a: J, b: J) => number

  /**
   * 比較
   * @param a A
   * @param b B
   * @returns 同じか
   */
  compare = (
    a: EntityDataPubType<J, EmptyJsonPub>,
    b: EntityDataPubType<J, EmptyJsonPub>,
  ) => this.comparePvt(a.data, b.data);

  /**
   * JSONから生成
   * @param props プロパティ
   * @returns Entity
   */
  createFromJson(props: EntityDataPubType<J, EmptyJsonPub>): E {
    return this.createFromJsonPvt(props.data);
  }

  /**
   * データから生成
   * @param props プロパティ
   * @returns Entity
   */
  createFromEntityDataType = (
    props: EntityDataType,
  ) => this.createFromEntityType({ data: props.data, pub: null });
}
